import { deactivateStudentReport } from 'apis/Payment/Subscription';
import { useAppStore } from 'hooks/useAppStore';
import moment from 'moment';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { ErrorResponse } from 'types';
import { fetchServerError } from 'utils';

export const useDeactivateStudentReport = () => {
  const queryClient = useQueryClient();
  const {
    subscriptionStore: { currentSubscription, updateCurrentSubscription },
    workspaceStore: { currentWorkspaceId },
  } = useAppStore();

  return useMutation(deactivateStudentReport, {
    onSuccess: () => {
      const subscriptionEndsAt = moment(currentSubscription?.currentPeriodEnd).format('LL');
      updateCurrentSubscription({ ...currentSubscription, cancelStudentReportAtPeriodEnd: true });
      toast.success(`Learner Report will be deactivated on ${subscriptionEndsAt}`);
      queryClient.invalidateQueries(['workspaces', currentWorkspaceId, 'usage-record']);
    },
    onError: (error: ErrorResponse) => {
      toast(fetchServerError(error), { type: 'error' });
    },
  });
};
